import { GRID_DIMENSIONS } from "./constants";

/**
 * Calculate the optimal table height based on the number of rows
 * @param rowCount Number of data rows
 * @param maxHeight Maximum height constraint (default: window.innerHeight)
 * @param customPadding Custom padding override (default: rowHeight)
 * @returns Calculated height as string with px unit
 */
export const getTableHeight = (
  rowCount: number,
  maxHeight: number = window.innerHeight,
  customPadding?: number,
): string => {
  // Smart default: rowHeight for better visual spacing
  const padding = customPadding ?? GRID_DIMENSIONS.ROW_HEIGHT;

  // Calculate height based on actual data rows, but at least minRows
  const rowsToShow = Math.max(rowCount, GRID_DIMENSIONS.MIN_ROWS);
  const calculatedHeight =
    rowsToShow * GRID_DIMENSIONS.ROW_HEIGHT +
    GRID_DIMENSIONS.HEADER_HEIGHT +
    padding;

  // Ensure it doesn't exceed maxHeight
  const finalHeight = Math.min(calculatedHeight, maxHeight);

  return `${finalHeight}px`;
};

/**
 * Calculate the minimum table height for consistent UI
 * @param customPadding Custom padding override (default: rowHeight)
 * @returns Minimum height as string with px unit
 */
export const getMinTableHeight = (customPadding?: number): string => {
  // Smart default: rowHeight for better visual spacing
  const padding = customPadding ?? GRID_DIMENSIONS.ROW_HEIGHT;

  return `${
    (GRID_DIMENSIONS.MIN_ROWS * GRID_DIMENSIONS.ROW_HEIGHT) +
    GRID_DIMENSIONS.HEADER_HEIGHT +
    padding
  }px`;
};
